import { Component, Input } from '@angular/core';
import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector   : 'wor-export-email',
  template: require('./export.email.component.html')
})
export class ExportEmailComponent {
  @Input() icon = 'cloud-download';

  @Input() type: string;

  email: string;

  constructor (
    public activeModal: NgbActiveModal
  ) {}
}
